import script from "./OutgoingCallNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./OutgoingCallNotification.vue?vue&type=script&setup=true&lang=js"

import "./OutgoingCallNotification.scss?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__